<template>
  <div class="test-record-container">
    <!-- 搜索区域 -->
    <div class="search-bar">
      <el-input v-model="searchForm.phone_number" placeholder="请输入手机号码" clearable size="large"
        style="width: 200px; margin-right: 15px" @keyup.enter="handleSearch">
        <template #prefix>
          <el-icon>
            <Search />
          </el-icon>
        </template>
      </el-input>

      <el-select v-model="searchForm.send_status" placeholder="发送状态" clearable size="large" style="width: 130px; margin-right: 15px">
        <el-option label="全部" value="" />
        <el-option label="成功" value="success" />
        <el-option label="失败" value="failed" />
        <el-option label="发送中" value="pending" />
      </el-select>

      <el-select v-model="searchForm.test_type" placeholder="测试类型" clearable size="large" style="width: 130px; margin-right: 15px">
        <el-option label="全部" value="" />
        <el-option label="模板测试" value="template" />
        <el-option label="内容测试" value="content" />
      </el-select>

      <el-date-picker
        v-model="searchForm.date_range"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="large"
        style="width: 300px; margin-right: 15px"
        @change="handleDateChange"
      />

      <el-button type="primary" size="large" @click="handleSearch">
        <el-icon>
          <Search />
        </el-icon>
        搜索
      </el-button>

      <el-button type="warning" size="large" @click="handleReset" style="margin-left: 10px">
        <el-icon>
          <Refresh />
        </el-icon>
        重置
      </el-button>

      <el-button type="success" size="large" @click="exportRecords" style="float: right">
        <el-icon>
          <Download />
        </el-icon>
        导出记录
      </el-button>
    </div>

    <!-- 测试记录列表 -->
    <el-table :data="recordList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="account_name" label="账户名称" width="180" />
      <el-table-column prop="phone_number" label="手机号码" width="130" />
      <el-table-column prop="test_type" label="测试类型" width="100">
        <template #default="{ row }">
          <el-tag :type="row.test_type === 'template' ? 'primary' : 'success'">
            {{ row.test_type === 'template' ? '模板测试' : '内容测试' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="template_code" label="模板CODE" width="150" />
      <el-table-column prop="final_content" label="发送内容" min-width="200">
        <template #default="{ row }">
          <div class="content-preview" :title="row.final_content">
            {{ row.final_content }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="send_status" label="发送状态" width="100" align="center">
        <template #default="{ row }">
          <el-tag :type="getStatusTagType(row.send_status)">
            {{ getStatusText(row.send_status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sms_count" label="短信条数" width="90" align="center" />
      <el-table-column prop="request_id" label="请求ID" width="180">
        <template #default="{ row }">
          <div class="request-id" :title="row.request_id">
            {{ row.request_id || '-' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="error_message" label="错误信息" min-width="200">
        <template #default="{ row }">
          <div v-if="row.error_message" class="error-message" :title="row.error_message">
            {{ row.error_message }}
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="ip_address" label="IP地址" width="130" />
      <el-table-column prop="create_time" label="创建时间" width="180" />

      <el-table-column label="操作" width="120" fixed="right">
        <template #default="scope">
          <el-button type="primary" size="small" @click="viewDetail(scope.row)">
            <el-icon>
              <View />
            </el-icon>
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
        :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
        @size-change="fetchRecordList" @current-change="fetchRecordList" />
    </div>

    <!-- 详情对话框 -->
    <el-dialog v-model="detailDialogVisible" title="测试记录详情" width="700px">
      <el-descriptions :column="2" border v-if="currentRecord">
        <el-descriptions-item label="记录ID">{{ currentRecord.id }}</el-descriptions-item>
        <el-descriptions-item label="账户名称">{{ currentRecord.account_name }}</el-descriptions-item>
        <el-descriptions-item label="手机号码">{{ currentRecord.phone_number }}</el-descriptions-item>
        <el-descriptions-item label="测试类型">
          <el-tag :type="currentRecord.test_type === 'template' ? 'primary' : 'success'">
            {{ currentRecord.test_type === 'template' ? '模板测试' : '内容测试' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="发送状态">
          <el-tag :type="getStatusTagType(currentRecord.send_status)">
            {{ getStatusText(currentRecord.send_status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="短信条数">{{ currentRecord.sms_count }}</el-descriptions-item>
        <el-descriptions-item label="请求ID">{{ currentRecord.request_id || '-' }}</el-descriptions-item>
        <el-descriptions-item label="IP地址">{{ currentRecord.ip_address }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ currentRecord.create_time }}</el-descriptions-item>
        
        <el-descriptions-item label="模板CODE" :span="2">{{ currentRecord.template_code || '-' }}</el-descriptions-item>
        
        <el-descriptions-item label="模板内容" :span="2" v-if="currentRecord.template_content">
          <div class="content-box">{{ currentRecord.template_content }}</div>
        </el-descriptions-item>
        
        <el-descriptions-item label="模板变量" :span="2" v-if="currentRecord.template_variables">
          <div class="json-box">
            <pre>{{ formatJson(currentRecord.template_variables) }}</pre>
          </div>
        </el-descriptions-item>
        
        <el-descriptions-item label="最终内容" :span="2">
          <div class="content-box">{{ currentRecord.final_content }}</div>
        </el-descriptions-item>
        
        <el-descriptions-item label="错误信息" :span="2" v-if="currentRecord.error_message">
          <div class="error-box">{{ currentRecord.error_message }}</div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <!-- 统计信息卡片 -->
    <div class="stats-cards" v-if="statsData">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card shadow="hover" class="stats-card">
            <div class="stats-content">
              <div class="stats-icon success">
                <el-icon><SuccessFilled /></el-icon>
              </div>
              <div class="stats-info">
                <div class="stats-value">{{ statsData.success_count || 0 }}</div>
                <div class="stats-label">发送成功</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="stats-card">
            <div class="stats-content">
              <div class="stats-icon error">
                <el-icon><WarningFilled /></el-icon>
              </div>
              <div class="stats-info">
                <div class="stats-value">{{ statsData.failed_count || 0 }}</div>
                <div class="stats-label">发送失败</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="stats-card">
            <div class="stats-content">
              <div class="stats-icon warning">
                <el-icon><Clock /></el-icon>
              </div>
              <div class="stats-info">
                <div class="stats-value">{{ statsData.pending_count || 0 }}</div>
                <div class="stats-label">发送中</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="stats-card">
            <div class="stats-content">
              <div class="stats-icon primary">
                <el-icon><Message /></el-icon>
              </div>
              <div class="stats-info">
                <div class="stats-value">{{ statsData.total_count || 0 }}</div>
                <div class="stats-label">总测试数</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Refresh, Download, View, SuccessFilled, WarningFilled, Clock, Message
} from '@element-plus/icons-vue'

export default {
  name: 'TestRecordView',
  components: { Search, Refresh, Download, View, SuccessFilled, WarningFilled, Clock, Message },
  props: {
    accountId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      detailDialogVisible: false,
      currentRecord: null,
      
      searchForm: {
        phone_number: '',
        send_status: '',
        test_type: '',
        date_range: [],
        start_date: '',
        end_date: ''
      },
      
      recordList: [],
      statsData: null,
      
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  mounted() {
    this.fetchRecordList()
    this.fetchStats()
  },
  watch: {
    accountId() {
      this.pagination.page = 1
      this.fetchRecordList()
      this.fetchStats()
    }
  },
  methods: {
    // 获取测试记录列表
    async fetchRecordList() {
      this.loading = true
      try {
        const params = {
          action: 'get_test_records',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }

        // 添加账户ID筛选
        if (this.accountId) {
          params.account_id = this.accountId
        }

        // 添加搜索条件
        if (this.searchForm.phone_number) {
          params.phone_number = this.searchForm.phone_number
        }
        if (this.searchForm.send_status) {
          params.send_status = this.searchForm.send_status
        }
        if (this.searchForm.test_type) {
          params.test_type = this.searchForm.test_type
        }
        if (this.searchForm.start_date) {
          params.start_date = this.searchForm.start_date
        }
        if (this.searchForm.end_date) {
          params.end_date = this.searchForm.end_date
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          params
        )

        if (data.data) {
          this.recordList = data.data
          this.pagination.total = data.pagination?.total || data.data.length
        }
      } catch (error) {
        this.$message.error('获取测试记录失败')
        console.error('获取测试记录错误:', error)
      } finally {
        this.loading = false
      }
    },

    // 获取统计信息
    async fetchStats() {
      try {
        const params = {
          action: 'get_test_stats',
          store_id: this.userInfo.id
        }

        if (this.accountId) {
          params.account_id = this.accountId
        }

        // 添加搜索条件到统计
        if (this.searchForm.phone_number) {
          params.phone_number = this.searchForm.phone_number
        }
        if (this.searchForm.send_status) {
          params.send_status = this.searchForm.send_status
        }
        if (this.searchForm.test_type) {
          params.test_type = this.searchForm.test_type
        }
        if (this.searchForm.start_date) {
          params.start_date = this.searchForm.start_date
        }
        if (this.searchForm.end_date) {
          params.end_date = this.searchForm.end_date
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          params
        )

        if (data.data) {
          this.statsData = data.data
        }
      } catch (error) {
        console.error('获取统计信息错误:', error)
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1
      this.fetchRecordList()
      this.fetchStats()
    },

    // 处理重置
    handleReset() {
      this.searchForm = {
        phone_number: '',
        send_status: '',
        test_type: '',
        date_range: [],
        start_date: '',
        end_date: ''
      }
      this.pagination.page = 1
      this.fetchRecordList()
      this.fetchStats()
    },

    // 处理日期变化
    handleDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.searchForm.start_date = this.formatDate(dateRange[0])
        this.searchForm.end_date = this.formatDate(dateRange[1])
      } else {
        this.searchForm.start_date = ''
        this.searchForm.end_date = ''
      }
    },

    // 查看详情
    viewDetail(record) {
      this.currentRecord = record
      this.detailDialogVisible = true
    },

    // 导出记录
    async exportRecords() {
      try {
        const params = {
          action: 'export_test_records',
          store_id: this.userInfo.id
        }

        if (this.accountId) {
          params.account_id = this.accountId
        }

        // 添加搜索条件
        if (this.searchForm.phone_number) {
          params.phone_number = this.searchForm.phone_number
        }
        if (this.searchForm.send_status) {
          params.send_status = this.searchForm.send_status
        }
        if (this.searchForm.test_type) {
          params.test_type = this.searchForm.test_type
        }
        if (this.searchForm.start_date) {
          params.start_date = this.searchForm.start_date
        }
        if (this.searchForm.end_date) {
          params.end_date = this.searchForm.end_date
        }

        const response = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          params,
          {
            responseType: 'blob'
          }
        )

        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `短信测试记录_${this.formatDate(new Date())}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        this.$message.success('导出成功')
      } catch (error) {
        this.$message.error('导出失败')
        console.error('导出记录错误:', error)
      }
    },

    // 获取状态显示文本
    getStatusText(status) {
      const statusMap = {
        'success': '成功',
        'failed': '失败',
        'pending': '发送中'
      }
      return statusMap[status] || status
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        'success': 'success',
        'failed': 'danger',
        'pending': 'warning'
      }
      return typeMap[status] || 'info'
    },

    // 格式化JSON
    formatJson(jsonString) {
      try {
        const obj = JSON.parse(jsonString)
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        return jsonString
      }
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped lang="scss">
.test-record-container {
  padding: 20px;

  .search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 16px;
    background: #f8fafc;
    border-radius: 8px;
  }

  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  .content-preview {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: help;
  }

  .request-id {
    font-family: monospace;
    font-size: 12px;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: help;
  }

  .error-message {
    color: #f56c6c;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: help;
  }

  .content-box {
    background: #f5f7fa;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    white-space: pre-wrap;
    word-break: break-all;
    font-size: 14px;
    line-height: 1.5;
  }

  .json-box {
    background: #f5f7fa;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    max-height: 200px;
    overflow: auto;
    
    pre {
      margin: 0;
      font-family: 'Courier New', monospace;
      font-size: 12px;
      line-height: 1.4;
    }
  }

  .error-box {
    background: #fef0f0;
    color: #f56c6c;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #fbc4c4;
    white-space: pre-wrap;
    word-break: break-all;
    font-size: 14px;
    line-height: 1.5;
  }

  .stats-cards {
    margin-bottom: 20px;
    
    .stats-card {
      .stats-content {
        display: flex;
        align-items: center;
        
        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;
          font-size: 24px;
          color: white;
          
          &.success {
            background: #67c23a;
          }
          
          &.error {
            background: #f56c6c;
          }
          
          &.warning {
            background: #e6a23c;
          }
          
          &.primary {
            background: #409eff;
          }
        }
        
        .stats-info {
          flex: 1;
          
          .stats-value {
            font-size: 24px;
            font-weight: bold;
            color: #303133;
            margin-bottom: 5px;
          }
          
          .stats-label {
            font-size: 14px;
            color: #909399;
          }
        }
      }
    }
  }
}

/* 表格样式优化 */
:deep(.el-table) {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  .el-table__header th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
  }

  .el-table__body tr:hover>td {
    background-color: #f0f7ff !important;
  }
}

/* 操作按钮样式 */
:deep(.el-button) {
  display: inline-flex;
  align-items: center;

  .el-icon {
    margin-right: 5px;
  }
}
</style>